import { Model } from '@df/catalog/model';
import { Filter } from '@df/catalog-ui/listing/filter/filter';
import { ListingFilter } from '@df/catalog-ui/listing/listing';

export const KLEVU_SEARCH_FILTER_TYPE = 'klevuSearch';

@ListingFilter({
    filterType: KLEVU_SEARCH_FILTER_TYPE
})
export class FilterKlevuSearch<T extends Model> extends Filter<T, number[] | undefined, string> {
    /**
     * Query filter alway has matches
     */
    readonly hasAnyMatches = true;

    /**
     * Search productsIds setter
     */
    set productsIds(value: number[] | undefined) {
        if (this._selection !== value) {
            this._selection = value;

            this.next();
        }
    }

    /**
     * Search productsIds getter
     */
    get productsIds(): number[] | undefined {
        return this._selection;
    }

    /**
     * Resets selection
     */
    reset() {
        if (this.hasSelection) {
            this.selection = undefined;
            // this.selection.sale = undefined;
            return this.next();
        }
    }

    /**
     * Applies filter to models collection
     * @param  {T[]} collection Input collection to filter
     * @return {T[]}            Filtered collection
     */
    applyFilter(collection: T[]): T[] {
        // do not apply if no bounds set
        if (!this.hasSelection) {
            return collection;
        }

        // filter collection
        return collection.filter(model => this.selection?.includes(model.id as number));
    }

    /**
     * Serializes selection to string
     */
    getState(): number[] {
        return [];
    }

    /**
     * Unserializes string | array to selection
     */
    setState(value: number[] | number) {}

    /**
     * Checks if filter is applied
     * @return {boolean}
     */
    get hasSelection(): boolean {
        return !!this.selection;
    }
}
